import CommonButtonView from "../../../../components/CommonButton/View/CommonButtonView";
import { RailwayDomain, RailwayDomainProjects } from "../Model/RailwayDomainModel";
import "../Styles/RailwayDomainStyles.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Configuration from "../../../../../config/configuration";

import RailwayImage from '../../../../../assets/image/Domains/Railways/railway_home.webp'
// const RailwayImage = `${Configuration.S3_URL}Domains/Railways/railway-image.webp`

const RailwayDomainView = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="railway-domain-view-main-container">

      {isMobile ? (
        <div className="railway-domain-view-main-container-landing-screen-main-container">
          <div className="railway-domain-view-main-container-landing-screen-main-container-wrapup">
            <div className="railway-domain-view-main-container-landing-screen-main-container-content-container">
              <span className="railway-domain-view-main-container-landing-screen-main-container-content-container-heading">{RailwayDomain?.mobHeading}</span>
              <span className="railway-domain-view-main-container-landing-screen-main-container-content-container-subheading">{RailwayDomain?.subHeading}</span>


            </div>
            <div className="railway-domain-view-main-container-landing-screen-main-container-image-container">
              <div className="railway-domain-view-main-container-landing-screen-main-container-image-container-image">
                <img src={RailwayImage} />
              </div>
            </div>

            <div className="railway-domain-points-container-flex-wrap-mobile">
              {RailwayDomain.solutions.map((point, i) => (
                <div key={i} className="railway-domain-points-container">
                  <span className="point-bullet">•</span>
                  <span className="point-title">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="railway-domain-view-main-container-landing-screen-main-container">
          <div className="railway-domain-view-main-container-landing-screen-main-container-wrapup">
            <div className="railway-domain-view-main-container-landing-screen-main-container-content-container">
              <span className="railway-domain-view-main-container-landing-screen-main-container-content-container-heading">{RailwayDomain?.heading}</span>
              <span className="railway-domain-view-main-container-landing-screen-main-container-content-container-subheading">{RailwayDomain?.subHeading}</span>
              {RailwayDomain.solutions.map((point, i) => (
                <div key={i} className="railway-domain-points-container">
                  <span className="point-bullet">•</span>
                  <span className="point-title">{point}</span>
                </div>
              ))}

            </div>
            <div className="railway-domain-view-main-container-landing-screen-main-container-image-container">
              <div className="railway-domain-view-main-container-landing-screen-main-container-image-container-image">
                <img src={RailwayImage} />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        RailwayDomainProjects.map((value, index) => (
          <RailwaySolutions key={index} image={value.mobileimage} heading={value.product} />
        ))
      ) : (
        RailwayDomainProjects.map((value, index) => (
          <RailwaySolutions key={index} image={value.image} heading={value.product} />
        ))
      )}
    </div>
  )
};

export default RailwayDomainView;

const RailwaySolutions = ({ heading, image }) => {
  return (
    <div className="railway-solutions-main-view-container">
      <span className='railway-domain-page-view-main-container-features-heading'>{heading}</span>
      <div className="railway-solutions-main-view-container-image">
        <img src={image} />
      </div>
    </div>
  )
}